module.exports = __webpack_public_path__ + "img/max-office-building-add.ee601fb2.svg";